/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CallTargetExportSfBody } from '../models';
// @ts-ignore
import { CallTargetSfSyncBody } from '../models';
// @ts-ignore
import { CreateCallTargetProductAssociationRequest } from '../models';
// @ts-ignore
import { CreateCallTargetProductCategoryAssociation201Response } from '../models';
// @ts-ignore
import { CreateCallTargetProductCategoryAssociationRequest } from '../models';
// @ts-ignore
import { CreateTask200Response } from '../models';
// @ts-ignore
import { GetCallTarget200Response } from '../models';
// @ts-ignore
import { GetCallTargetProductCategoryAssociations200Response } from '../models';
// @ts-ignore
import { GetCallTargetProductCategoryAssociations200ResponseProductCategoryAssociationsInnerCallTargetProductAssociationsInner } from '../models';
// @ts-ignore
import { GetMailRemindItems200Response } from '../models';
// @ts-ignore
import { GetNextPageFirstId200Response } from '../models';
// @ts-ignore
import { MergeCallTargetsBody } from '../models';
// @ts-ignore
import { UpdateCallTargetProductCategoryAssociationRequest } from '../models';
/**
 * CallTargetApi - axios parameter creator
 * @export
 */
export const CallTargetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 単一CallTargetのsfへのエクスポートAPI
         * @summary 単一CallTargetのsfへのエクスポート
         * @param {number} callTargetId リードID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callTargetExportSf: async (callTargetId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callTargetId' is not null or undefined
            assertParamExists('callTargetExportSf', 'callTargetId', callTargetId)
            const localVarPath = `/api/user/call_targets/{call_target_id}/export_sf`
                .replace(`{${"call_target_id"}}`, encodeURIComponent(String(callTargetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 単一CallTargetのsf同期API
         * @summary 単一CallTargetのsf同期
         * @param {number} callTargetId リードID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callTargetSfSync: async (callTargetId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callTargetId' is not null or undefined
            assertParamExists('callTargetSfSync', 'callTargetId', callTargetId)
            const localVarPath = `/api/user/call_targets/{call_target_id}/sf_sync`
                .replace(`{${"call_target_id"}}`, encodeURIComponent(String(callTargetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * リードの商材カテゴリ紐付けに商材を紐付けるAPI
         * @summary リード×商材紐付け作成API
         * @param {number} callTargetProductCategoryAssociationId 商材カテゴリ紐付けID
         * @param {CreateCallTargetProductAssociationRequest} createCallTargetProductAssociationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallTargetProductAssociation: async (callTargetProductCategoryAssociationId: number, createCallTargetProductAssociationRequest: CreateCallTargetProductAssociationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callTargetProductCategoryAssociationId' is not null or undefined
            assertParamExists('createCallTargetProductAssociation', 'callTargetProductCategoryAssociationId', callTargetProductCategoryAssociationId)
            // verify required parameter 'createCallTargetProductAssociationRequest' is not null or undefined
            assertParamExists('createCallTargetProductAssociation', 'createCallTargetProductAssociationRequest', createCallTargetProductAssociationRequest)
            const localVarPath = `/api/user/call_target_product_category_associations/{call_target_product_category_association_id}/product_associations`
                .replace(`{${"call_target_product_category_association_id"}}`, encodeURIComponent(String(callTargetProductCategoryAssociationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCallTargetProductAssociationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * リードに商材カテゴリを紐付けするAPI
         * @summary リード×商材カテゴリ紐付け追加API
         * @param {number} callTargetId リードID
         * @param {CreateCallTargetProductCategoryAssociationRequest} createCallTargetProductCategoryAssociationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallTargetProductCategoryAssociation: async (callTargetId: number, createCallTargetProductCategoryAssociationRequest: CreateCallTargetProductCategoryAssociationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callTargetId' is not null or undefined
            assertParamExists('createCallTargetProductCategoryAssociation', 'callTargetId', callTargetId)
            // verify required parameter 'createCallTargetProductCategoryAssociationRequest' is not null or undefined
            assertParamExists('createCallTargetProductCategoryAssociation', 'createCallTargetProductCategoryAssociationRequest', createCallTargetProductCategoryAssociationRequest)
            const localVarPath = `/api/user/call_targets/{call_target_id}/product_category_associations`
                .replace(`{${"call_target_id"}}`, encodeURIComponent(String(callTargetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCallTargetProductCategoryAssociationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * リードの商材カテゴリ紐付けから商材の紐付けを削除するAPI
         * @summary リード×商材紐付け削除API
         * @param {number} callTargetProductCategoryAssociationId 商材カテゴリ紐付けID
         * @param {number} id 商材紐付けID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCallTargetProductAssociation: async (callTargetProductCategoryAssociationId: number, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callTargetProductCategoryAssociationId' is not null or undefined
            assertParamExists('deleteCallTargetProductAssociation', 'callTargetProductCategoryAssociationId', callTargetProductCategoryAssociationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCallTargetProductAssociation', 'id', id)
            const localVarPath = `/api/user/call_target_product_category_associations/{call_target_product_category_association_id}/product_associations/{id}`
                .replace(`{${"call_target_product_category_association_id"}}`, encodeURIComponent(String(callTargetProductCategoryAssociationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * リードに紐づく商材カテゴリ紐付けを削除するAPI
         * @summary リード×商材カテゴリ紐付け削除API
         * @param {number} id 商材カテゴリ紐付けID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyCallTargetProductCategoryAssociation: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyCallTargetProductCategoryAssociation', 'id', id)
            const localVarPath = `/api/user/product_category_associations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 単体リード情報取得API
         * @summary 単体リード情報取得API
         * @param {number} callTargetId リードID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallTarget: async (callTargetId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callTargetId' is not null or undefined
            assertParamExists('getCallTarget', 'callTargetId', callTargetId)
            const localVarPath = `/api/user/call_targets/{call_target_id}`
                .replace(`{${"call_target_id"}}`, encodeURIComponent(String(callTargetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * リードに紐づく商材カテゴリ紐付けの一覧を取得するAPI
         * @summary リード×商材カテゴリ紐付け一覧取得API
         * @param {number} callTargetId リードID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallTargetProductCategoryAssociations: async (callTargetId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callTargetId' is not null or undefined
            assertParamExists('getCallTargetProductCategoryAssociations', 'callTargetId', callTargetId)
            const localVarPath = `/api/user/call_targets/{call_target_id}/product_category_associations`
                .replace(`{${"call_target_id"}}`, encodeURIComponent(String(callTargetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * メールリマインド情報取得API
         * @summary メールリマインド情報取得API
         * @param {number} [userId] ユーザーID
         * @param {boolean} [draft] 下書き
         * @param {boolean} [reserved] 配信予約
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailRemindItems: async (userId?: number, draft?: boolean, reserved?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/call_targets/mail_remind_items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (draft !== undefined) {
                localVarQueryParameter['draft'] = draft;
            }

            if (reserved !== undefined) {
                localVarQueryParameter['reserved'] = reserved;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 「前へ」で使うID取得処理API
         * @summary 「前へ」で使うID取得処理API
         * @param {string} [lf] リードリストのフィルターパラメータ
         * @param {string} [sortKey] リードリストのソートキー
         * @param {number} [currentDisplayNumber] リードリストで表示するリード数
         * @param {number} [currentPage] リードリストでの現在のページネーション
         * @param {string} [sortOrder] リードリストのソート順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextPageFirstId: async (lf?: string, sortKey?: string, currentDisplayNumber?: number, currentPage?: number, sortOrder?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/call_targets/next_page_first_id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (lf !== undefined) {
                localVarQueryParameter['lf'] = lf;
            }

            if (sortKey !== undefined) {
                localVarQueryParameter['sortKey'] = sortKey;
            }

            if (currentDisplayNumber !== undefined) {
                localVarQueryParameter['currentDisplayNumber'] = currentDisplayNumber;
            }

            if (currentPage !== undefined) {
                localVarQueryParameter['currentPage'] = currentPage;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 「次へ」で使うID取得処理API
         * @summary 「次へ」で使うID取得処理API
         * @param {string} [lf] リードリストのフィルターパラメータ
         * @param {string} [sortKey] リードリストのソートキー
         * @param {number} [currentDisplayNumber] リードリストで表示するリード数
         * @param {number} [currentPage] リードリストでの現在のページネーション
         * @param {string} [sortOrder] リードリストのソート順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviousPageLastId: async (lf?: string, sortKey?: string, currentDisplayNumber?: number, currentPage?: number, sortOrder?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/call_targets/previous_page_last_id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (lf !== undefined) {
                localVarQueryParameter['lf'] = lf;
            }

            if (sortKey !== undefined) {
                localVarQueryParameter['sortKey'] = sortKey;
            }

            if (currentDisplayNumber !== undefined) {
                localVarQueryParameter['currentDisplayNumber'] = currentDisplayNumber;
            }

            if (currentPage !== undefined) {
                localVarQueryParameter['currentPage'] = currentPage;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * リード重複統合API
         * @summary リード重複統合API
         * @param {MergeCallTargetsBody} [mergeCallTargetsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeCallTargets: async (mergeCallTargetsBody?: MergeCallTargetsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/call_targets/merge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mergeCallTargetsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * リードに紐づく商材カテゴリ紐付けのステータスを更新するAPI
         * @summary リード×商材カテゴリ紐付けステータス更新API
         * @param {number} id 商材カテゴリ紐付けID
         * @param {UpdateCallTargetProductCategoryAssociationRequest} updateCallTargetProductCategoryAssociationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCallTargetProductCategoryAssociation: async (id: number, updateCallTargetProductCategoryAssociationRequest: UpdateCallTargetProductCategoryAssociationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCallTargetProductCategoryAssociation', 'id', id)
            // verify required parameter 'updateCallTargetProductCategoryAssociationRequest' is not null or undefined
            assertParamExists('updateCallTargetProductCategoryAssociation', 'updateCallTargetProductCategoryAssociationRequest', updateCallTargetProductCategoryAssociationRequest)
            const localVarPath = `/api/user/product_category_associations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCallTargetProductCategoryAssociationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallTargetApi - functional programming interface
 * @export
 */
export const CallTargetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallTargetApiAxiosParamCreator(configuration)
    return {
        /**
         * 単一CallTargetのsfへのエクスポートAPI
         * @summary 単一CallTargetのsfへのエクスポート
         * @param {number} callTargetId リードID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callTargetExportSf(callTargetId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallTargetExportSfBody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callTargetExportSf(callTargetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 単一CallTargetのsf同期API
         * @summary 単一CallTargetのsf同期
         * @param {number} callTargetId リードID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callTargetSfSync(callTargetId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallTargetSfSyncBody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callTargetSfSync(callTargetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * リードの商材カテゴリ紐付けに商材を紐付けるAPI
         * @summary リード×商材紐付け作成API
         * @param {number} callTargetProductCategoryAssociationId 商材カテゴリ紐付けID
         * @param {CreateCallTargetProductAssociationRequest} createCallTargetProductAssociationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCallTargetProductAssociation(callTargetProductCategoryAssociationId: number, createCallTargetProductAssociationRequest: CreateCallTargetProductAssociationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCallTargetProductCategoryAssociations200ResponseProductCategoryAssociationsInnerCallTargetProductAssociationsInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCallTargetProductAssociation(callTargetProductCategoryAssociationId, createCallTargetProductAssociationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * リードに商材カテゴリを紐付けするAPI
         * @summary リード×商材カテゴリ紐付け追加API
         * @param {number} callTargetId リードID
         * @param {CreateCallTargetProductCategoryAssociationRequest} createCallTargetProductCategoryAssociationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCallTargetProductCategoryAssociation(callTargetId: number, createCallTargetProductCategoryAssociationRequest: CreateCallTargetProductCategoryAssociationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCallTargetProductCategoryAssociation201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCallTargetProductCategoryAssociation(callTargetId, createCallTargetProductCategoryAssociationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * リードの商材カテゴリ紐付けから商材の紐付けを削除するAPI
         * @summary リード×商材紐付け削除API
         * @param {number} callTargetProductCategoryAssociationId 商材カテゴリ紐付けID
         * @param {number} id 商材紐付けID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCallTargetProductAssociation(callTargetProductCategoryAssociationId: number, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCallTargetProductAssociation(callTargetProductCategoryAssociationId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * リードに紐づく商材カテゴリ紐付けを削除するAPI
         * @summary リード×商材カテゴリ紐付け削除API
         * @param {number} id 商材カテゴリ紐付けID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyCallTargetProductCategoryAssociation(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyCallTargetProductCategoryAssociation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 単体リード情報取得API
         * @summary 単体リード情報取得API
         * @param {number} callTargetId リードID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallTarget(callTargetId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCallTarget200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallTarget(callTargetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * リードに紐づく商材カテゴリ紐付けの一覧を取得するAPI
         * @summary リード×商材カテゴリ紐付け一覧取得API
         * @param {number} callTargetId リードID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallTargetProductCategoryAssociations(callTargetId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCallTargetProductCategoryAssociations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallTargetProductCategoryAssociations(callTargetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * メールリマインド情報取得API
         * @summary メールリマインド情報取得API
         * @param {number} [userId] ユーザーID
         * @param {boolean} [draft] 下書き
         * @param {boolean} [reserved] 配信予約
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMailRemindItems(userId?: number, draft?: boolean, reserved?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMailRemindItems200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMailRemindItems(userId, draft, reserved, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 「前へ」で使うID取得処理API
         * @summary 「前へ」で使うID取得処理API
         * @param {string} [lf] リードリストのフィルターパラメータ
         * @param {string} [sortKey] リードリストのソートキー
         * @param {number} [currentDisplayNumber] リードリストで表示するリード数
         * @param {number} [currentPage] リードリストでの現在のページネーション
         * @param {string} [sortOrder] リードリストのソート順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextPageFirstId(lf?: string, sortKey?: string, currentDisplayNumber?: number, currentPage?: number, sortOrder?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNextPageFirstId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextPageFirstId(lf, sortKey, currentDisplayNumber, currentPage, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 「次へ」で使うID取得処理API
         * @summary 「次へ」で使うID取得処理API
         * @param {string} [lf] リードリストのフィルターパラメータ
         * @param {string} [sortKey] リードリストのソートキー
         * @param {number} [currentDisplayNumber] リードリストで表示するリード数
         * @param {number} [currentPage] リードリストでの現在のページネーション
         * @param {string} [sortOrder] リードリストのソート順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreviousPageLastId(lf?: string, sortKey?: string, currentDisplayNumber?: number, currentPage?: number, sortOrder?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNextPageFirstId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreviousPageLastId(lf, sortKey, currentDisplayNumber, currentPage, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * リード重複統合API
         * @summary リード重複統合API
         * @param {MergeCallTargetsBody} [mergeCallTargetsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeCallTargets(mergeCallTargetsBody?: MergeCallTargetsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTask200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeCallTargets(mergeCallTargetsBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * リードに紐づく商材カテゴリ紐付けのステータスを更新するAPI
         * @summary リード×商材カテゴリ紐付けステータス更新API
         * @param {number} id 商材カテゴリ紐付けID
         * @param {UpdateCallTargetProductCategoryAssociationRequest} updateCallTargetProductCategoryAssociationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCallTargetProductCategoryAssociation(id: number, updateCallTargetProductCategoryAssociationRequest: UpdateCallTargetProductCategoryAssociationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCallTargetProductCategoryAssociation(id, updateCallTargetProductCategoryAssociationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CallTargetApi - factory interface
 * @export
 */
export const CallTargetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallTargetApiFp(configuration)
    return {
        /**
         * 単一CallTargetのsfへのエクスポートAPI
         * @summary 単一CallTargetのsfへのエクスポート
         * @param {number} callTargetId リードID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callTargetExportSf(callTargetId: number, options?: any): AxiosPromise<CallTargetExportSfBody> {
            return localVarFp.callTargetExportSf(callTargetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 単一CallTargetのsf同期API
         * @summary 単一CallTargetのsf同期
         * @param {number} callTargetId リードID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callTargetSfSync(callTargetId: number, options?: any): AxiosPromise<CallTargetSfSyncBody> {
            return localVarFp.callTargetSfSync(callTargetId, options).then((request) => request(axios, basePath));
        },
        /**
         * リードの商材カテゴリ紐付けに商材を紐付けるAPI
         * @summary リード×商材紐付け作成API
         * @param {number} callTargetProductCategoryAssociationId 商材カテゴリ紐付けID
         * @param {CreateCallTargetProductAssociationRequest} createCallTargetProductAssociationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallTargetProductAssociation(callTargetProductCategoryAssociationId: number, createCallTargetProductAssociationRequest: CreateCallTargetProductAssociationRequest, options?: any): AxiosPromise<GetCallTargetProductCategoryAssociations200ResponseProductCategoryAssociationsInnerCallTargetProductAssociationsInner> {
            return localVarFp.createCallTargetProductAssociation(callTargetProductCategoryAssociationId, createCallTargetProductAssociationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * リードに商材カテゴリを紐付けするAPI
         * @summary リード×商材カテゴリ紐付け追加API
         * @param {number} callTargetId リードID
         * @param {CreateCallTargetProductCategoryAssociationRequest} createCallTargetProductCategoryAssociationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallTargetProductCategoryAssociation(callTargetId: number, createCallTargetProductCategoryAssociationRequest: CreateCallTargetProductCategoryAssociationRequest, options?: any): AxiosPromise<CreateCallTargetProductCategoryAssociation201Response> {
            return localVarFp.createCallTargetProductCategoryAssociation(callTargetId, createCallTargetProductCategoryAssociationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * リードの商材カテゴリ紐付けから商材の紐付けを削除するAPI
         * @summary リード×商材紐付け削除API
         * @param {number} callTargetProductCategoryAssociationId 商材カテゴリ紐付けID
         * @param {number} id 商材紐付けID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCallTargetProductAssociation(callTargetProductCategoryAssociationId: number, id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCallTargetProductAssociation(callTargetProductCategoryAssociationId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * リードに紐づく商材カテゴリ紐付けを削除するAPI
         * @summary リード×商材カテゴリ紐付け削除API
         * @param {number} id 商材カテゴリ紐付けID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyCallTargetProductCategoryAssociation(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.destroyCallTargetProductCategoryAssociation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 単体リード情報取得API
         * @summary 単体リード情報取得API
         * @param {number} callTargetId リードID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallTarget(callTargetId: number, options?: any): AxiosPromise<GetCallTarget200Response> {
            return localVarFp.getCallTarget(callTargetId, options).then((request) => request(axios, basePath));
        },
        /**
         * リードに紐づく商材カテゴリ紐付けの一覧を取得するAPI
         * @summary リード×商材カテゴリ紐付け一覧取得API
         * @param {number} callTargetId リードID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallTargetProductCategoryAssociations(callTargetId: number, options?: any): AxiosPromise<GetCallTargetProductCategoryAssociations200Response> {
            return localVarFp.getCallTargetProductCategoryAssociations(callTargetId, options).then((request) => request(axios, basePath));
        },
        /**
         * メールリマインド情報取得API
         * @summary メールリマインド情報取得API
         * @param {number} [userId] ユーザーID
         * @param {boolean} [draft] 下書き
         * @param {boolean} [reserved] 配信予約
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailRemindItems(userId?: number, draft?: boolean, reserved?: boolean, options?: any): AxiosPromise<GetMailRemindItems200Response> {
            return localVarFp.getMailRemindItems(userId, draft, reserved, options).then((request) => request(axios, basePath));
        },
        /**
         * 「前へ」で使うID取得処理API
         * @summary 「前へ」で使うID取得処理API
         * @param {string} [lf] リードリストのフィルターパラメータ
         * @param {string} [sortKey] リードリストのソートキー
         * @param {number} [currentDisplayNumber] リードリストで表示するリード数
         * @param {number} [currentPage] リードリストでの現在のページネーション
         * @param {string} [sortOrder] リードリストのソート順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextPageFirstId(lf?: string, sortKey?: string, currentDisplayNumber?: number, currentPage?: number, sortOrder?: string, options?: any): AxiosPromise<GetNextPageFirstId200Response> {
            return localVarFp.getNextPageFirstId(lf, sortKey, currentDisplayNumber, currentPage, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 「次へ」で使うID取得処理API
         * @summary 「次へ」で使うID取得処理API
         * @param {string} [lf] リードリストのフィルターパラメータ
         * @param {string} [sortKey] リードリストのソートキー
         * @param {number} [currentDisplayNumber] リードリストで表示するリード数
         * @param {number} [currentPage] リードリストでの現在のページネーション
         * @param {string} [sortOrder] リードリストのソート順
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviousPageLastId(lf?: string, sortKey?: string, currentDisplayNumber?: number, currentPage?: number, sortOrder?: string, options?: any): AxiosPromise<GetNextPageFirstId200Response> {
            return localVarFp.getPreviousPageLastId(lf, sortKey, currentDisplayNumber, currentPage, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * リード重複統合API
         * @summary リード重複統合API
         * @param {MergeCallTargetsBody} [mergeCallTargetsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeCallTargets(mergeCallTargetsBody?: MergeCallTargetsBody, options?: any): AxiosPromise<CreateTask200Response> {
            return localVarFp.mergeCallTargets(mergeCallTargetsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * リードに紐づく商材カテゴリ紐付けのステータスを更新するAPI
         * @summary リード×商材カテゴリ紐付けステータス更新API
         * @param {number} id 商材カテゴリ紐付けID
         * @param {UpdateCallTargetProductCategoryAssociationRequest} updateCallTargetProductCategoryAssociationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCallTargetProductCategoryAssociation(id: number, updateCallTargetProductCategoryAssociationRequest: UpdateCallTargetProductCategoryAssociationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateCallTargetProductCategoryAssociation(id, updateCallTargetProductCategoryAssociationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallTargetApi - interface
 * @export
 * @interface CallTargetApi
 */
export interface CallTargetApiInterface {
    /**
     * 単一CallTargetのsfへのエクスポートAPI
     * @summary 単一CallTargetのsfへのエクスポート
     * @param {number} callTargetId リードID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApiInterface
     */
    callTargetExportSf(callTargetId: number, options?: AxiosRequestConfig): AxiosPromise<CallTargetExportSfBody>;

    /**
     * 単一CallTargetのsf同期API
     * @summary 単一CallTargetのsf同期
     * @param {number} callTargetId リードID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApiInterface
     */
    callTargetSfSync(callTargetId: number, options?: AxiosRequestConfig): AxiosPromise<CallTargetSfSyncBody>;

    /**
     * リードの商材カテゴリ紐付けに商材を紐付けるAPI
     * @summary リード×商材紐付け作成API
     * @param {number} callTargetProductCategoryAssociationId 商材カテゴリ紐付けID
     * @param {CreateCallTargetProductAssociationRequest} createCallTargetProductAssociationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApiInterface
     */
    createCallTargetProductAssociation(callTargetProductCategoryAssociationId: number, createCallTargetProductAssociationRequest: CreateCallTargetProductAssociationRequest, options?: AxiosRequestConfig): AxiosPromise<GetCallTargetProductCategoryAssociations200ResponseProductCategoryAssociationsInnerCallTargetProductAssociationsInner>;

    /**
     * リードに商材カテゴリを紐付けするAPI
     * @summary リード×商材カテゴリ紐付け追加API
     * @param {number} callTargetId リードID
     * @param {CreateCallTargetProductCategoryAssociationRequest} createCallTargetProductCategoryAssociationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApiInterface
     */
    createCallTargetProductCategoryAssociation(callTargetId: number, createCallTargetProductCategoryAssociationRequest: CreateCallTargetProductCategoryAssociationRequest, options?: AxiosRequestConfig): AxiosPromise<CreateCallTargetProductCategoryAssociation201Response>;

    /**
     * リードの商材カテゴリ紐付けから商材の紐付けを削除するAPI
     * @summary リード×商材紐付け削除API
     * @param {number} callTargetProductCategoryAssociationId 商材カテゴリ紐付けID
     * @param {number} id 商材紐付けID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApiInterface
     */
    deleteCallTargetProductAssociation(callTargetProductCategoryAssociationId: number, id: number, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * リードに紐づく商材カテゴリ紐付けを削除するAPI
     * @summary リード×商材カテゴリ紐付け削除API
     * @param {number} id 商材カテゴリ紐付けID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApiInterface
     */
    destroyCallTargetProductCategoryAssociation(id: number, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 単体リード情報取得API
     * @summary 単体リード情報取得API
     * @param {number} callTargetId リードID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApiInterface
     */
    getCallTarget(callTargetId: number, options?: AxiosRequestConfig): AxiosPromise<GetCallTarget200Response>;

    /**
     * リードに紐づく商材カテゴリ紐付けの一覧を取得するAPI
     * @summary リード×商材カテゴリ紐付け一覧取得API
     * @param {number} callTargetId リードID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApiInterface
     */
    getCallTargetProductCategoryAssociations(callTargetId: number, options?: AxiosRequestConfig): AxiosPromise<GetCallTargetProductCategoryAssociations200Response>;

    /**
     * メールリマインド情報取得API
     * @summary メールリマインド情報取得API
     * @param {number} [userId] ユーザーID
     * @param {boolean} [draft] 下書き
     * @param {boolean} [reserved] 配信予約
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApiInterface
     */
    getMailRemindItems(userId?: number, draft?: boolean, reserved?: boolean, options?: AxiosRequestConfig): AxiosPromise<GetMailRemindItems200Response>;

    /**
     * 「前へ」で使うID取得処理API
     * @summary 「前へ」で使うID取得処理API
     * @param {string} [lf] リードリストのフィルターパラメータ
     * @param {string} [sortKey] リードリストのソートキー
     * @param {number} [currentDisplayNumber] リードリストで表示するリード数
     * @param {number} [currentPage] リードリストでの現在のページネーション
     * @param {string} [sortOrder] リードリストのソート順
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApiInterface
     */
    getNextPageFirstId(lf?: string, sortKey?: string, currentDisplayNumber?: number, currentPage?: number, sortOrder?: string, options?: AxiosRequestConfig): AxiosPromise<GetNextPageFirstId200Response>;

    /**
     * 「次へ」で使うID取得処理API
     * @summary 「次へ」で使うID取得処理API
     * @param {string} [lf] リードリストのフィルターパラメータ
     * @param {string} [sortKey] リードリストのソートキー
     * @param {number} [currentDisplayNumber] リードリストで表示するリード数
     * @param {number} [currentPage] リードリストでの現在のページネーション
     * @param {string} [sortOrder] リードリストのソート順
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApiInterface
     */
    getPreviousPageLastId(lf?: string, sortKey?: string, currentDisplayNumber?: number, currentPage?: number, sortOrder?: string, options?: AxiosRequestConfig): AxiosPromise<GetNextPageFirstId200Response>;

    /**
     * リード重複統合API
     * @summary リード重複統合API
     * @param {MergeCallTargetsBody} [mergeCallTargetsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApiInterface
     */
    mergeCallTargets(mergeCallTargetsBody?: MergeCallTargetsBody, options?: AxiosRequestConfig): AxiosPromise<CreateTask200Response>;

    /**
     * リードに紐づく商材カテゴリ紐付けのステータスを更新するAPI
     * @summary リード×商材カテゴリ紐付けステータス更新API
     * @param {number} id 商材カテゴリ紐付けID
     * @param {UpdateCallTargetProductCategoryAssociationRequest} updateCallTargetProductCategoryAssociationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApiInterface
     */
    updateCallTargetProductCategoryAssociation(id: number, updateCallTargetProductCategoryAssociationRequest: UpdateCallTargetProductCategoryAssociationRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for callTargetExportSf operation in CallTargetApi.
 * @export
 * @interface CallTargetApiCallTargetExportSfRequest
 */
export interface CallTargetApiCallTargetExportSfRequest {
    /**
     * リードID
     * @type {number}
     * @memberof CallTargetApiCallTargetExportSf
     */
    readonly callTargetId: number
}

/**
 * Request parameters for callTargetSfSync operation in CallTargetApi.
 * @export
 * @interface CallTargetApiCallTargetSfSyncRequest
 */
export interface CallTargetApiCallTargetSfSyncRequest {
    /**
     * リードID
     * @type {number}
     * @memberof CallTargetApiCallTargetSfSync
     */
    readonly callTargetId: number
}

/**
 * Request parameters for createCallTargetProductAssociation operation in CallTargetApi.
 * @export
 * @interface CallTargetApiCreateCallTargetProductAssociationRequest
 */
export interface CallTargetApiCreateCallTargetProductAssociationRequest {
    /**
     * 商材カテゴリ紐付けID
     * @type {number}
     * @memberof CallTargetApiCreateCallTargetProductAssociation
     */
    readonly callTargetProductCategoryAssociationId: number

    /**
     * 
     * @type {CreateCallTargetProductAssociationRequest}
     * @memberof CallTargetApiCreateCallTargetProductAssociation
     */
    readonly createCallTargetProductAssociationRequest: CreateCallTargetProductAssociationRequest
}

/**
 * Request parameters for createCallTargetProductCategoryAssociation operation in CallTargetApi.
 * @export
 * @interface CallTargetApiCreateCallTargetProductCategoryAssociationRequest
 */
export interface CallTargetApiCreateCallTargetProductCategoryAssociationRequest {
    /**
     * リードID
     * @type {number}
     * @memberof CallTargetApiCreateCallTargetProductCategoryAssociation
     */
    readonly callTargetId: number

    /**
     * 
     * @type {CreateCallTargetProductCategoryAssociationRequest}
     * @memberof CallTargetApiCreateCallTargetProductCategoryAssociation
     */
    readonly createCallTargetProductCategoryAssociationRequest: CreateCallTargetProductCategoryAssociationRequest
}

/**
 * Request parameters for deleteCallTargetProductAssociation operation in CallTargetApi.
 * @export
 * @interface CallTargetApiDeleteCallTargetProductAssociationRequest
 */
export interface CallTargetApiDeleteCallTargetProductAssociationRequest {
    /**
     * 商材カテゴリ紐付けID
     * @type {number}
     * @memberof CallTargetApiDeleteCallTargetProductAssociation
     */
    readonly callTargetProductCategoryAssociationId: number

    /**
     * 商材紐付けID
     * @type {number}
     * @memberof CallTargetApiDeleteCallTargetProductAssociation
     */
    readonly id: number
}

/**
 * Request parameters for destroyCallTargetProductCategoryAssociation operation in CallTargetApi.
 * @export
 * @interface CallTargetApiDestroyCallTargetProductCategoryAssociationRequest
 */
export interface CallTargetApiDestroyCallTargetProductCategoryAssociationRequest {
    /**
     * 商材カテゴリ紐付けID
     * @type {number}
     * @memberof CallTargetApiDestroyCallTargetProductCategoryAssociation
     */
    readonly id: number
}

/**
 * Request parameters for getCallTarget operation in CallTargetApi.
 * @export
 * @interface CallTargetApiGetCallTargetRequest
 */
export interface CallTargetApiGetCallTargetRequest {
    /**
     * リードID
     * @type {number}
     * @memberof CallTargetApiGetCallTarget
     */
    readonly callTargetId: number
}

/**
 * Request parameters for getCallTargetProductCategoryAssociations operation in CallTargetApi.
 * @export
 * @interface CallTargetApiGetCallTargetProductCategoryAssociationsRequest
 */
export interface CallTargetApiGetCallTargetProductCategoryAssociationsRequest {
    /**
     * リードID
     * @type {number}
     * @memberof CallTargetApiGetCallTargetProductCategoryAssociations
     */
    readonly callTargetId: number
}

/**
 * Request parameters for getMailRemindItems operation in CallTargetApi.
 * @export
 * @interface CallTargetApiGetMailRemindItemsRequest
 */
export interface CallTargetApiGetMailRemindItemsRequest {
    /**
     * ユーザーID
     * @type {number}
     * @memberof CallTargetApiGetMailRemindItems
     */
    readonly userId?: number

    /**
     * 下書き
     * @type {boolean}
     * @memberof CallTargetApiGetMailRemindItems
     */
    readonly draft?: boolean

    /**
     * 配信予約
     * @type {boolean}
     * @memberof CallTargetApiGetMailRemindItems
     */
    readonly reserved?: boolean
}

/**
 * Request parameters for getNextPageFirstId operation in CallTargetApi.
 * @export
 * @interface CallTargetApiGetNextPageFirstIdRequest
 */
export interface CallTargetApiGetNextPageFirstIdRequest {
    /**
     * リードリストのフィルターパラメータ
     * @type {string}
     * @memberof CallTargetApiGetNextPageFirstId
     */
    readonly lf?: string

    /**
     * リードリストのソートキー
     * @type {string}
     * @memberof CallTargetApiGetNextPageFirstId
     */
    readonly sortKey?: string

    /**
     * リードリストで表示するリード数
     * @type {number}
     * @memberof CallTargetApiGetNextPageFirstId
     */
    readonly currentDisplayNumber?: number

    /**
     * リードリストでの現在のページネーション
     * @type {number}
     * @memberof CallTargetApiGetNextPageFirstId
     */
    readonly currentPage?: number

    /**
     * リードリストのソート順
     * @type {string}
     * @memberof CallTargetApiGetNextPageFirstId
     */
    readonly sortOrder?: string
}

/**
 * Request parameters for getPreviousPageLastId operation in CallTargetApi.
 * @export
 * @interface CallTargetApiGetPreviousPageLastIdRequest
 */
export interface CallTargetApiGetPreviousPageLastIdRequest {
    /**
     * リードリストのフィルターパラメータ
     * @type {string}
     * @memberof CallTargetApiGetPreviousPageLastId
     */
    readonly lf?: string

    /**
     * リードリストのソートキー
     * @type {string}
     * @memberof CallTargetApiGetPreviousPageLastId
     */
    readonly sortKey?: string

    /**
     * リードリストで表示するリード数
     * @type {number}
     * @memberof CallTargetApiGetPreviousPageLastId
     */
    readonly currentDisplayNumber?: number

    /**
     * リードリストでの現在のページネーション
     * @type {number}
     * @memberof CallTargetApiGetPreviousPageLastId
     */
    readonly currentPage?: number

    /**
     * リードリストのソート順
     * @type {string}
     * @memberof CallTargetApiGetPreviousPageLastId
     */
    readonly sortOrder?: string
}

/**
 * Request parameters for mergeCallTargets operation in CallTargetApi.
 * @export
 * @interface CallTargetApiMergeCallTargetsRequest
 */
export interface CallTargetApiMergeCallTargetsRequest {
    /**
     * 
     * @type {MergeCallTargetsBody}
     * @memberof CallTargetApiMergeCallTargets
     */
    readonly mergeCallTargetsBody?: MergeCallTargetsBody
}

/**
 * Request parameters for updateCallTargetProductCategoryAssociation operation in CallTargetApi.
 * @export
 * @interface CallTargetApiUpdateCallTargetProductCategoryAssociationRequest
 */
export interface CallTargetApiUpdateCallTargetProductCategoryAssociationRequest {
    /**
     * 商材カテゴリ紐付けID
     * @type {number}
     * @memberof CallTargetApiUpdateCallTargetProductCategoryAssociation
     */
    readonly id: number

    /**
     * 
     * @type {UpdateCallTargetProductCategoryAssociationRequest}
     * @memberof CallTargetApiUpdateCallTargetProductCategoryAssociation
     */
    readonly updateCallTargetProductCategoryAssociationRequest: UpdateCallTargetProductCategoryAssociationRequest
}

/**
 * CallTargetApi - object-oriented interface
 * @export
 * @class CallTargetApi
 * @extends {BaseAPI}
 */
export class CallTargetApi extends BaseAPI implements CallTargetApiInterface {
    /**
     * 単一CallTargetのsfへのエクスポートAPI
     * @summary 単一CallTargetのsfへのエクスポート
     * @param {CallTargetApiCallTargetExportSfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApi
     */
    public callTargetExportSf(requestParameters: CallTargetApiCallTargetExportSfRequest, options?: AxiosRequestConfig) {
        return CallTargetApiFp(this.configuration).callTargetExportSf(requestParameters.callTargetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 単一CallTargetのsf同期API
     * @summary 単一CallTargetのsf同期
     * @param {CallTargetApiCallTargetSfSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApi
     */
    public callTargetSfSync(requestParameters: CallTargetApiCallTargetSfSyncRequest, options?: AxiosRequestConfig) {
        return CallTargetApiFp(this.configuration).callTargetSfSync(requestParameters.callTargetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * リードの商材カテゴリ紐付けに商材を紐付けるAPI
     * @summary リード×商材紐付け作成API
     * @param {CallTargetApiCreateCallTargetProductAssociationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApi
     */
    public createCallTargetProductAssociation(requestParameters: CallTargetApiCreateCallTargetProductAssociationRequest, options?: AxiosRequestConfig) {
        return CallTargetApiFp(this.configuration).createCallTargetProductAssociation(requestParameters.callTargetProductCategoryAssociationId, requestParameters.createCallTargetProductAssociationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * リードに商材カテゴリを紐付けするAPI
     * @summary リード×商材カテゴリ紐付け追加API
     * @param {CallTargetApiCreateCallTargetProductCategoryAssociationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApi
     */
    public createCallTargetProductCategoryAssociation(requestParameters: CallTargetApiCreateCallTargetProductCategoryAssociationRequest, options?: AxiosRequestConfig) {
        return CallTargetApiFp(this.configuration).createCallTargetProductCategoryAssociation(requestParameters.callTargetId, requestParameters.createCallTargetProductCategoryAssociationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * リードの商材カテゴリ紐付けから商材の紐付けを削除するAPI
     * @summary リード×商材紐付け削除API
     * @param {CallTargetApiDeleteCallTargetProductAssociationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApi
     */
    public deleteCallTargetProductAssociation(requestParameters: CallTargetApiDeleteCallTargetProductAssociationRequest, options?: AxiosRequestConfig) {
        return CallTargetApiFp(this.configuration).deleteCallTargetProductAssociation(requestParameters.callTargetProductCategoryAssociationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * リードに紐づく商材カテゴリ紐付けを削除するAPI
     * @summary リード×商材カテゴリ紐付け削除API
     * @param {CallTargetApiDestroyCallTargetProductCategoryAssociationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApi
     */
    public destroyCallTargetProductCategoryAssociation(requestParameters: CallTargetApiDestroyCallTargetProductCategoryAssociationRequest, options?: AxiosRequestConfig) {
        return CallTargetApiFp(this.configuration).destroyCallTargetProductCategoryAssociation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 単体リード情報取得API
     * @summary 単体リード情報取得API
     * @param {CallTargetApiGetCallTargetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApi
     */
    public getCallTarget(requestParameters: CallTargetApiGetCallTargetRequest, options?: AxiosRequestConfig) {
        return CallTargetApiFp(this.configuration).getCallTarget(requestParameters.callTargetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * リードに紐づく商材カテゴリ紐付けの一覧を取得するAPI
     * @summary リード×商材カテゴリ紐付け一覧取得API
     * @param {CallTargetApiGetCallTargetProductCategoryAssociationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApi
     */
    public getCallTargetProductCategoryAssociations(requestParameters: CallTargetApiGetCallTargetProductCategoryAssociationsRequest, options?: AxiosRequestConfig) {
        return CallTargetApiFp(this.configuration).getCallTargetProductCategoryAssociations(requestParameters.callTargetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * メールリマインド情報取得API
     * @summary メールリマインド情報取得API
     * @param {CallTargetApiGetMailRemindItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApi
     */
    public getMailRemindItems(requestParameters: CallTargetApiGetMailRemindItemsRequest = {}, options?: AxiosRequestConfig) {
        return CallTargetApiFp(this.configuration).getMailRemindItems(requestParameters.userId, requestParameters.draft, requestParameters.reserved, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 「前へ」で使うID取得処理API
     * @summary 「前へ」で使うID取得処理API
     * @param {CallTargetApiGetNextPageFirstIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApi
     */
    public getNextPageFirstId(requestParameters: CallTargetApiGetNextPageFirstIdRequest = {}, options?: AxiosRequestConfig) {
        return CallTargetApiFp(this.configuration).getNextPageFirstId(requestParameters.lf, requestParameters.sortKey, requestParameters.currentDisplayNumber, requestParameters.currentPage, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 「次へ」で使うID取得処理API
     * @summary 「次へ」で使うID取得処理API
     * @param {CallTargetApiGetPreviousPageLastIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApi
     */
    public getPreviousPageLastId(requestParameters: CallTargetApiGetPreviousPageLastIdRequest = {}, options?: AxiosRequestConfig) {
        return CallTargetApiFp(this.configuration).getPreviousPageLastId(requestParameters.lf, requestParameters.sortKey, requestParameters.currentDisplayNumber, requestParameters.currentPage, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * リード重複統合API
     * @summary リード重複統合API
     * @param {CallTargetApiMergeCallTargetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApi
     */
    public mergeCallTargets(requestParameters: CallTargetApiMergeCallTargetsRequest = {}, options?: AxiosRequestConfig) {
        return CallTargetApiFp(this.configuration).mergeCallTargets(requestParameters.mergeCallTargetsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * リードに紐づく商材カテゴリ紐付けのステータスを更新するAPI
     * @summary リード×商材カテゴリ紐付けステータス更新API
     * @param {CallTargetApiUpdateCallTargetProductCategoryAssociationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetApi
     */
    public updateCallTargetProductCategoryAssociation(requestParameters: CallTargetApiUpdateCallTargetProductCategoryAssociationRequest, options?: AxiosRequestConfig) {
        return CallTargetApiFp(this.configuration).updateCallTargetProductCategoryAssociation(requestParameters.id, requestParameters.updateCallTargetProductCategoryAssociationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
